import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
This is the left side navigation thats used in /org/:orgName/settings
It should be used for the entire platform
We're maintaining two until we migrate everything else to this one
*/ import { isNavigationItem } from './interfaces';
import { MenuItem } from './menu-item';
function LeftSideNavigationMenu(param) {
    let { items } = param;
    if (!items.length) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "w-[255px] h-full flex flex-col gap-3",
        "data-e2e": "LEFT_SIDE_NAVIGATION_MENU",
        children: items.map((item)=>{
            return isNavigationItem(item) ? /*#__PURE__*/ _jsx(MenuItem, {
                item: item,
                disabled: item.disabled
            }, item.id) : /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "px-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider",
                        children: item.title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col gap-1",
                        children: item.items.map((subItem)=>/*#__PURE__*/ _jsx(MenuItem, {
                                item: subItem,
                                disabled: subItem.disabled
                            }, subItem.id))
                    })
                ]
            }, item.id);
        })
    });
}
export { LeftSideNavigationMenu };
